import apiClient from "@/services/api-client";

export const usageRevenueService = {
  meters: async () => (await apiClient.get("/billing-automation/meters")).data,
  createMeter: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/billing-automation/meters", payload)).data,
  setMeterStatus: async (id: string, isActive: boolean) =>
    (
      await apiClient.patch(`/billing-automation/meters/${id}/status`, {
        isActive,
      })
    ).data,
  events: async (params?: { tenantId?: string; meterCode?: string }) =>
    (await apiClient.get("/billing-automation/events", { params })).data,
  ingestEvent: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/billing-automation/events", payload)).data,
  aggregates: async (params?: { status?: string; tenantId?: string }) =>
    (await apiClient.get("/billing-automation/aggregates", { params })).data,
  calculateAggregate: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/billing-automation/aggregates/calculate", payload))
      .data,
  finalizeAggregate: async (id: string, payload: Record<string, unknown>) =>
    (
      await apiClient.post(
        `/billing-automation/aggregates/${id}/finalize`,
        payload,
      )
    ).data,
  revenueSchedules: async (tenantId?: string) =>
    (
      await apiClient.get("/billing-automation/revenue-schedules", {
        params: { tenantId },
      })
    ).data,
  createRevenueSchedule: async (
    invoiceId: string,
    payload: Record<string, unknown>,
  ) =>
    (
      await apiClient.post(
        `/billing-automation/invoices/${invoiceId}/revenue-schedule`,
        payload,
      )
    ).data,
  recognizeRevenue: async (id: string, payload: Record<string, unknown>) =>
    (
      await apiClient.post(
        `/billing-automation/revenue-schedules/${id}/recognize`,
        payload,
      )
    ).data,
  revenueForecast: async () =>
    (await apiClient.get("/billing-automation/revenue-forecast")).data,
};
